import React, { useState, useEffect } from 'react';
import '../../style/DashBoard.scss';
// Firebase
import app from '../../components/firebase/fire';
// components
import Header from '../../components/private/Header';
// react bootstrap
import {
  Form,
  Button,
  Row,
  Col,
  Spinner,
  Card,
  InputGroup,
  FormControl,
} from 'react-bootstrap';
// react redux
import { connect } from 'react-redux';
import * as actionType from '../../store/action';

function DashBoard({ data, image_update, image_delete }) {
  const db = app.firestore();
  const [file, setFile] = useState(null);
  const [newFileLocation, setNewFileLocation] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [metaData, setMetaData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState(null);
  // file Handler
  const fileHandler = (e) => {
    setFile(e.target.files[0]);
  };

  // upload handler
  const uploadHandler = async () => {
    if (file !== null) {
      setLoading(true);
      const storageRef = app.storage().ref();
      const fileRef = storageRef.child(`images/${file.name}`);
      await fileRef.put(file);
      await fileRef.getDownloadURL().then((location) => {
        setNewFileLocation(location);
      });
    } else {
      alert('no file to upload');
    }
  };

  // delete Images
  const deleteHandler = async (id) => {
    setLoading(true);
    setSelectedFile(null);
    // delete from reducer
    image_delete(id);
    // delete from Firebase-DataBase
    db.collection('Images')
      .doc(id)
      .delete()
      .catch(function (error) {
        console.error('Error removing document: ', error);
      });
    // delete from Firebase-Storage
    const storageRef = app.storage().ref();
    // Create a reference to the file to delete
    var desertRef = storageRef.child(`images/${id}`);
    // Delete the file
    desertRef
      .delete()
      .then(function () {
        setLoading(false);
      })
      .catch(function (error) {
        console.error('Error removing document: ', error);
      });
  };

  //File Metadata Handler
  const fileMetaData = async (name) => {
    const storageRef = await app.storage().ref();
    // Create a reference to the file whose metadata we want to retrieve
    var forestRef = await storageRef.child(`images/${name}`);

    // Get metadata properties
    forestRef
      .getMetadata()
      .then(function (metadata) {
        // Metadata now contains the metadata for 'images/forest.jpg'
        setMetaData(metadata);
      })
      .catch(function (error) {
        // Uh-oh, an error occurred!
      });
  };
  useEffect(() => {
    const getData = async () => {
      db.collection('Images')
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            image_update(doc.data());
          });
        });
    };
    getData();
  }, []);

  useEffect(() => {
    if (newFileLocation !== null) {
      db.collection('Images')
        .doc(file.name)
        .set({
          name: file.name,
          location: newFileLocation,
        })
        .then(function () {
          image_update({
            name: file.name,
            location: newFileLocation,
          });
          setLoading(false);
          setFile(null);
        })
        .catch(function (error) {
          console.error('Error writing document ', error);
        });
    }
  }, [newFileLocation]);

  return (
    <>
      {loading ? (
        <div className='loader'>
          <p>
            <Spinner
              as='span'
              animation='grow'
              size='sm'
              role='status'
              aria-hidden='true'
              className='mr-2'
            />
            Please wait ...
          </p>
        </div>
      ) : (
        <>
          <Header />
          <Row className='w-100'>
            <Col className=' '>
              {/* input */}
              <Form>
                <Form.Group className='d-flex  justify-content-center mt-3 align-items-center'>
                  <Form.File id='upload' onChange={(e) => fileHandler(e)} />
                  <Button onClick={() => uploadHandler()}>upload</Button>
                </Form.Group>
              </Form>
            </Col>
          </Row>
          <Row className='d-flex align-items-center justify-content-center w-100 '>
            <Col sm={8}>
              <Form>
                <InputGroup size='sm' className='mb-3'>
                  <InputGroup.Prepend>
                    <InputGroup.Text id='inputGroup-sizing-sm'>
                      Search
                    </InputGroup.Text>
                  </InputGroup.Prepend>
                  <FormControl
                    aria-label='Small'
                    aria-describedby='inputGroup-sizing-sm'
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                </InputGroup>
              </Form>
              <div className='fileSection'>
                {data !== null && searchValue !== null
                  ? data
                      .filter((el) => el.name.includes(searchValue))
                      .map((el) => (
                        <Card
                          style={{ width: '10rem' }}
                          key={el.location}
                          className='card'
                          onClick={() => {
                            setSelectedFile(el);
                            fileMetaData(el.name);
                          }}
                        >
                          <Card.Img variant='top' src={el.location} />
                          <Card.ImgOverlay className='overlayText'>
                            <Card.Text className='cardText'>
                              {el.name}
                            </Card.Text>
                          </Card.ImgOverlay>
                        </Card>
                      ))
                  : data !== null
                  ? data.map((el) => (
                      <Card
                        style={{ width: '10rem' }}
                        key={el.location}
                        className='card'
                        onClick={() => {
                          setSelectedFile(el);
                          fileMetaData(el.name);
                        }}
                      >
                        <Card.Img variant='top' src={el.location} />
                        <Card.ImgOverlay className='overlayText'>
                          <Card.Text className='cardText'>{el.name}</Card.Text>
                        </Card.ImgOverlay>
                      </Card>
                    ))
                  : ''}
              </div>
            </Col>
            <Col sm={3} className='descriptionSection  '>
              {selectedFile === null ? (
                <p className='text-muted'>
                  Please select a file to see the Details
                </p>
              ) : (
                <div className='text-left'>
                  <div>
                    <p>
                      {' '}
                      <b> Name: </b>
                      {selectedFile.name}
                    </p>
                    <p>
                      <b>Size: </b>
                      {metaData !== null
                        ? metaData.size / 1000
                        : 'Calculating...'}{' '}
                      KB
                    </p>
                    <p>
                      <b>Date: </b>
                      {metaData !== null
                        ? metaData.timeCreated
                        : 'Loading...'}{' '}
                    </p>
                    <div>
                      {' '}
                      <b>location: </b>
                      {selectedFile.location}
                    </div>
                    <div className='text-center m-3'>
                      <Button onClick={() => deleteHandler(selectedFile.name)}>
                        Delete
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.image.files,
  };
};

const mapActionToProps = (dispatch) => {
  return {
    image_update: (item) =>
      dispatch({ type: actionType.FILE_UPDATE, newFile: item }),
    image_delete: (name) =>
      dispatch({ type: actionType.FILE_DELETE, name: name }),
  };
};

export default connect(mapStateToProps, mapActionToProps)(DashBoard);
